import { readTable } from '../store/localDb.store'
import type { LocalRow } from '../types/localDb.types'
import { idOf } from './c07.shared'

/**
 * Bentuk rack bersama (Master Lokasi MST-06 dan denah INV-01): posisi `mt_rack_bin` per rack dan bentuk bay → level →
 * jumlah posisi (prototype `JalRack.racks`). Bentuk tidak harus seragam, mis. [[3,3,3],[3,3],[4,4,3]].
 */
const digits = (value: unknown) => Number.parseInt(String(value ?? '').replace(/\D/g, ''), 10) || 0

export const binsOfRack = (rackId: string) => readTable('mt_rack_bin').filter(bin => idOf(bin.rack_id) === rackId)

/** Nomor bay / level / posisi dari kolom posisi, atau dari kode `R01-B01-L01-P01` bila kolomnya kosong. */
export const binPart = (bin: LocalRow, field: 'column' | 'level' | 'position') => {
  const direct = digits(bin[field])
  if (direct) return direct
  const part = String(bin.code).split('-')[field === 'column' ? 1 : field === 'level' ? 2 : 3]
  return digits(part) || 1
}

export function shapeFromPositions(positions: { b: number; l: number; p: number }[]) {
  const shape: number[][] = []
  positions.forEach(item => {
    const levels = shape[item.b - 1] ?? []
    shape[item.b - 1] = levels
    for (let index = 0; index < item.l; index += 1) levels[index] = levels[index] ?? 0
    levels[item.l - 1] = Math.max(levels[item.l - 1] ?? 0, item.p)
  })
  for (let index = 0; index < shape.length; index += 1) shape[index] = shape[index] ?? []
  const ext = {
    bay: shape.length,
    lv: shape.reduce((max, levels) => Math.max(max, levels.length), 0),
    pos: shape.reduce((max, levels) => levels.reduce((top, n) => Math.max(top, n), max), 0)
  }
  return { shape, ext }
}
